import Element from '../UI/Element';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Overlay from '../UI/Overlay';
import Renderable from '../../Component/Renderable';
import Sprite from '../Sprite';
import Text from '../Text';
import Point from '../../Utility/Point';
import { applyDefaultButtonAnimation } from '../../System/UI/UIHelper';
import Interactable from '../../Component/Interactable';
import SDKIntegrationsHelper from '../../Utility/SDK/SDKIntegrationsHelper';
import TransformComponent from '../../Component/Transform';
import Game from '../../Game';
import { Anim } from '../../System/Animation/AnimationHelper';
import { Easing } from '@tweenjs/tween.js';
import CleanupManager from '../../Utility/CleanupManager';
import { isNative } from 'Utility/Platform';

export class MyPetMiniGameShareUi extends Element {
    private overlay: Overlay;
    private image: Element;
    private buttonBg: GameObject<PIXI.Sprite>;
    private button: GameObject<PIXI.Sprite>;
    private readonly cleanupManager: CleanupManager = new CleanupManager();

    public create(): void {
        super.create({});

        this.getComponent(Renderable).visible = false;

        this.overlay = GameObject.Instantiate(Overlay, {
            name: 'overlay',
            preventInteraction: true,
            anchors: [0, 0, 1, 1],
            alpha: 0.5,
            color: [0, 0, 0, 225],
        });
        this.overlay.addComponent(Interactable);
        this.overlay.getComponent(Interactable).enabled = true;
        this.addChild(this.overlay);

        this.image = GameObject.Instantiate(Element, {
            layout: {
                anchors: [0, 0, 1, 1],
                pivot: [0.5, 0.5],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'pet_minigame_jackpot_share_popup',
                    },
                },
            ],
        });
        this.image.addComponent(TransformComponent);
        this.addChild(this.image);

        this.buttonBg = GameObject.Instantiate(Sprite, {
            texture: 'blank',
            anchor: new Point(0.5, 0.5),
            x: this.image.getComponent(TransformComponent).width / 2,
            y: 430,
            scale: new Point(0.9, 0.9),
        });
        this.image.addChild(this.buttonBg);

        if (!isNative()) {
            this.button = GameObject.Instantiate(Sprite, {
                texture: 'button_medium_blue',
                anchor: new Point(0.5, 0.5),
                y: 3,
            });
            this.buttonBg.addChild(this.button);

            applyDefaultButtonAnimation(this.button);
            this.button.addComponent(Interactable);
            this.button.getComponent(Interactable).buttonMode = true;
            this.button.on(GameObjectEvent.SELECTED, this.handleShareClick);
            this.cleanupManager.add(() => {
                this.button.off(GameObjectEvent.SELECTED, this.handleShareClick);
            });

            const shareText = GameObject.Instantiate(Text, {
                text: Game.locale.getText('Share'),
                style: Game.style.getStyle('popup.blue_btn'),
                anchor: new Point(0.5, 0.5),
                y: -5,
            });
            this.button.addChild(shareText);

            // disable share for samsung/azerion
            this.button.getComponent(Interactable).visible = false;
        }
    }

    public async show(): Promise<void> {
        const renderable = this.getComponent(Renderable);
        renderable.visible = true;
        renderable.alpha = 0;

        const imageTransform = this.image.getComponent(TransformComponent);
        imageTransform.scale.set(0);

        const buttonBgTransform = this.buttonBg.getComponent(TransformComponent);
        const buttonBgScale = buttonBgTransform.scale.clone();
        buttonBgTransform.scale.set(0);

        Anim(this, {
            alpha: 1,
            duration: 300,
        });

        Anim(this.image, {
            scaleX: 1,
            scaleY: 1,
            duration: 300,
            delay: 300,
            easing: Easing.Back.Out,
        });

        Anim(this.buttonBg, {
            scaleX: buttonBgScale.x,
            scaleY: buttonBgScale.y,
            duration: 400,
            easing: Easing.Back.Out,
            delay: 500,
        });
    }

    private readonly handleShareClick = (): void => {
        SDKIntegrationsHelper.shareMyPetMiniGameJackpot({});
    };

    public destroy(): void {
        this.cleanupManager.cleanUpAll();
        super.destroy();
    }
}
